import React, { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { ErrorBoundary } from "react-error-boundary";
import { Head } from "../Head";
import { HelmetProvider } from "react-helmet-async";

import { Theme } from "@radix-ui/themes";
import "@radix-ui/themes/styles.css";

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { resources } from "../../locales/locales";

import { AuthProvider } from "../../contexts/AuthContext";
import Routes from "../../routes";
import { useAppStore } from "../../stores/RootStore";

import { Settings } from "luxon";
import {setDefaultOptions} from "date-fns"
import { ru } from "date-fns/locale";
import ErrorFallback from "../errors/ErrorFallback";

function App() {
  const state = useAppStore();
  useEffect(() => {
    const currentSite = state.currentSite;
    const currentUser = state.currentUser?.attributes;
    // if (currentSite === null || currentUser === null) {
    //   return;
    // }

    i18n.use(initReactI18next).init({
      resources,
      lng: currentUser?.locale || "",
      fallbackLng: "ru",
    });
    setDefaultOptions({ locale: ru, weekStartsOn: 1 });
    
    // Luxon Settings
    Settings.defaultLocale = currentUser?.locale || "ru";
    Settings.defaultZone = state?.currentSite?.timezone ? state?.currentSite?.timezone : "Europe/Moscow";
  }, [state]);

  return (
    <BrowserRouter>
      <ErrorBoundary
        FallbackComponent={ErrorFallback}
        onReset={() => {
          window.location.reload();
        }}
      >
        <AuthProvider>
          <HelmetProvider>
            <Theme
              className="h-screen w-screen min-w-[960px]"
              appearance="dark"
              accentColor="blue"
              grayColor="slate"
              panelBackground="translucent"
              scaling="100%"
              radius="small"
            >
              <Routes />
            </Theme>
            <Head />
          </HelmetProvider>
        </AuthProvider>
      </ErrorBoundary>
    </BrowserRouter>
  );
}

export default App;
